// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PlayersEdit_pageHeader__35l9j","editSection":"PlayersEdit_editSection__VesGb","c-pointer":"PlayersEdit_c-pointer__3JjkJ"};